import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { RegisterService } from '../../register/register.service';

@Component({
  selector: 'app-modal-request-email',
  templateUrl: './modal-request-email.component.html',
  styleUrls: ['./modal-request-email.component.scss']
})
export class ModalRequestEmailComponent implements OnInit {
  isLoading: boolean;
  emailForm: FormGroup;
  errorMsg: string = null;

  constructor(
    public dialogRef: MatDialogRef<ModalRequestEmailComponent>,
    private fb: FormBuilder,
    private registerService: RegisterService,

  ) { }

  ngOnInit(): void {
    this.emailForm = this.fb.group({
      email: ['', [Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")]],
    })
  }

  confirm(value) {
    this.isLoading = true;
    // // console.log(value);
    this.registerService.checkEmail(value.email).pipe(
      map(res => {
        // // console.log(res);
        this.dialogRef.close({ email: value.email });
      }),
      catchError(err => {
        alert(err.error.message)
        this.isLoading = false;
        return of(null);
      })
    ).subscribe();

  }
}
